import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CommonService } from 'src/app/services/common.service';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { EventLogVO } from 'src/app/services/UserManagement';
import { AlertService } from 'src/app/shared/ims-alerts/ims-alerts.service';
import { Utils } from 'src/app/shared/utility/utils';

@Component({
	selector: 'app-shared-activity-log',
	templateUrl: './shared-activity-log.component.html',
	styleUrls: ['./shared-activity-log.component.scss'],
})
export class SharedActivityLogComponent implements OnInit {
	displayedColumns: string[] = ['eventDate', 'eventDisplayText', 'userFullName'];
	dataSource: MatTableDataSource<EventLogVO> = new MatTableDataSource();

	@Input() logs: any[];
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild(MatSort, { static: true }) sort: MatSort;
	filters: any = {};
	ariaResultAlert: number;

	constructor(private loader: LoadingService, private alert: AlertService, public cmnServ: CommonService) {}

	ngOnInit(): void {
		this.setupMatTable();
	}

	ngOnChanges(change) {
		if (change.logs) {
			this.dataSource.data = this.logs || [];
			this.dataSource._updateChangeSubscription();
		}
	}

	/**
	 * @description Setup matTable. Including dataSource initialization, binding of paginator and sorter,
	 * and setup default sort.
	 */
	setupMatTable() {
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort = this.sort;
		// setup default sort
		const sortState: Sort = { active: 'eventDate', direction: 'desc' };
		this.sort.active = sortState.active;
		this.sort.direction = sortState.direction;
	}

	/**
	 * @description filter content on one column
	 * @param filterValue filter query
	 * @param column column to filter on
	 * @todo put this function in a reusable location
	 */
	applyColumnFilter(filterValue: string, column: string) {
		this.filters[column] = filterValue;
		this.dataSource.filter = this.filters;
		if (this.dataSource.paginator) {
			this.dataSource.paginator.firstPage();
		}

		// For aria alert when user uses filter
		this.ariaResultAlert = this.dataSource.filteredData.length;
	}

	/**
	 * @description setup filter logic
	 * instead of sending pairs like "column: filterValue", now filters is an object that holds multiple key-value pairs.
	 */
	ngAfterViewInit() {
		this.dataSource.filterPredicate = (data, filters) => {
			const rs = this.displayedColumns.map((item) => {
				if (Utils.isNullCondition(filters[item])) {
					return true;
				}
				// get data from rows
				let rowValue = data[item] ? data[item] : '';
				let filterValue = filters[item];
				if (item === 'eventDate') {
					const date = new Date(rowValue);
					const dateString = date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
					return dateString.includes(filterValue);
				}
				return rowValue.toLowerCase().includes(filterValue.toLowerCase());
			});
			return rs.every(Boolean);
		};
	}
}
